import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getFormValues, isValid, reset, change } from 'redux-form';
import { Map, fromJS } from 'immutable';

import * as common from 'libs/commonFunc';

import { EduSummary } from 'components';

import * as eduActions from 'modules/edu';
import * as currentStatusActions from 'modules/currentStatus';

let SEARCH_VALUE = '';

class CtEduSummary extends Component {
  constructor(props) {
    super(props);

    const { eduParam } = this.props;
    const filterData = eduParam.get('filter').toJS();

    this.state = {
      filterState: 0,
      isEditExamData: { examNo: 0 },
      isLoading: false,
      isClicked: false
    };
    this.onSelectEduSummary = this.onSelectEduSummary.bind(this);
    this.onDeleteEdu = this.onDeleteEdu.bind(this);
    this.onPutEdu = this.onPutEdu.bind(this);
  }

  componentWillMount() {
    const { EduActions } = this.props;
    EduActions.changeEdu({ name: 'isMounting', value: true });
  }

  componentDidMount() {
    this.onGetEduSummary();
    // this.onGetTag();
    // this.onGetEduSummary();
  }

  componentDidUpdate(prevProps, prevState) {
    const { needReload, eduParam } = this.props;

    if (
      (needReload && !this.state.isLoading) ||
      // 필터
      eduParam !== prevProps.eduParam
    ) {
      this.onGetEduSummary();
    }
  }

  // 교육 리스트
  onGetEduSummary = async () => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        const { EduActions, eduParam } = this.props;
        const param = {
          filter: JSON.stringify(eduParam.get('filter'))
          // sort: JSON.stringify(eduParam.get('sort')),
          // offset: eduParam.get('limit') * page,
          // limit: eduParam.get('limit')
        };

        await EduActions.getEdu(param);
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  // 좌측 교육 리스트 선택하기
  onSelectEduSummary = eduNo => {
    const { CurrentStatusActions } = this.props;

    if (eduNo === 'all') {
      // 필터 초기화
      const { EduActions } = this.props;
      EduActions.getEdu();
      EduActions.changeEduParam({
        name: 'filter',
        value: Map({})
      });
      // // 대상자 리스트
      // EduActions.changeExamListParam({
      //   name: 'filter',
      //   value: Map({})
      // });
    }

    CurrentStatusActions.changeEduNo({ name: 'selectEduNo', value: eduNo });

    // 대상자 리스트
    // ExamListActions.changeExamListParam({
    //   name: 'filter',
    //   value: Map({})
    // });
  };

  // 교육 삭제
  onDeleteEdu = async eduNo => {
    const { EduActions, selectEduNo } = this.props;

    try {
      if (!!eduNo) {
        await EduActions.deleteEdu({ eduNo: eduNo });
      }

      this.onToggleModal('');
    } catch (e) {
      console.log(e);
    }

    // 현재 선택된 교육이 삭제될경우 전체교육으로 선택
    if (selectEduNo === eduNo) {
      this.onSelectEduSummary('all');
    }
  };

  // 교육 수정
  onPutEdu = async eduNo => {
    this.setState({ isClicked: true });

    setTimeout(async () => {
      try {
        const {
          EduActions,
          eduSummaryByEduNo,
          selectEditEduNo,
          formEduEdit,
          formStoreEdit,
          formEduEditIsValid
        } = this.props;

        if (!!formEduEdit && !!formEduEditIsValid) {
          let isEdit = false;
          const beforeData = eduSummaryByEduNo.get(String(selectEditEduNo));
          const params = {
            eduNo: eduNo
          };

          // if (formEduEdit.eduName !== '' && formEduEdit.content !== '') {
          if (formEduEdit.eduName) {
            // 교육명 수정
            if (formEduEdit.eduName !== beforeData.get('eduName')) {
              isEdit = true;
              params.eduName = formEduEdit.eduName;
            }

            // 교육 기간 수정
            // 교육 시작
            if (
              typeof formEduEdit.startEpoch !== 'undefined' &&
              formEduEdit.startEpoch.format('YYYY-MM-DD') !==
                common.timeFormatFromUTCEpoch(beforeData.get('startEpoch'), 3)
            ) {
              isEdit = true;
              // 훈련 시작일을 현재로 수정할 경우
              if (common.epochFromDate(formEduEdit.startEpoch) < common.nowEpoch()) {
                params.startEpoch = common.nowEpoch();
              } else {
                params.startEpoch = common.epochFromDate(formEduEdit.startEpoch);
              }
            }
            // 교육 종료
            if (
              typeof formEduEdit.endEpoch !== 'undefined' &&
              formEduEdit.endEpoch.format('YYYY-MM-DD') !== common.timeFormatFromUTCEpoch(beforeData.get('endEpoch'), 3)
            ) {
              isEdit = true;
              params.endEpoch = common.epochFromDate(formEduEdit.endEpoch);
            }
          }

          // 훈련 수정
          if (formEduEdit.examNoArray !== beforeData.get('examNoArray')) {
            isEdit = true;
            params.examNoArray = formEduEdit.examNoArray;
          }

          if (isEdit) {
            await EduActions.putEdu(params);

            this.onToggleModal('');
          } else {
            console.log('수정 사항 없음');
          }
        } else {
          window.markFieldValidate(formStoreEdit, 'formEduEdit');
        }

        this.setState({ isClicked: false });
      } catch (e) {
        console.log(e);
      }
    }, 100);
  };

  // 모달 처리
  onToggleModal = viewType => {
    const { ReduxFormReset, CurrentStatusActions } = this.props;
    ReduxFormReset('formEduEdit');
    ReduxFormReset('formEduDelete');

    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 교육 수정/삭제 모달
  onEduToggleModal = (eduNo, modalType) => {
    const { CurrentStatusActions } = this.props;

    if (!!eduNo) {
      // 선택한 번호 저장
      CurrentStatusActions.selectEditEduNo({ eduNo });

      this.onToggleModal(modalType);
    }
  };

  // 교육 검색 모드
  onSearchActive = () => {
    const { CurrentStatusActions, isSearchActive, eduParam } = this.props;

    // 검색 활성화
    CurrentStatusActions.changeEdu({ name: 'isSearchActive', value: !isSearchActive });
    // 검색 된 상태일 경우 검색어 입력
    CurrentStatusActions.changeEdu({ name: 'searchText', value: eduParam.getIn(['filter', 'searchAll']) });
  };

  // 교육 검색어 입력
  onChangeSearch = searchValue => {
    SEARCH_VALUE = searchValue;

    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.changeEdu({ name: 'searchText', value: SEARCH_VALUE });
  };

  onKeyupSearch = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.onSearch();
    }
  };

  // 검색 끄기
  onSearchBlur = () => {
    setTimeout(() => {
      let searchValue = '';
      searchValue = SEARCH_VALUE;
      const { eduParam, CurrentStatusActions } = this.props;

      if (searchValue !== eduParam.getIn(['filter', 'searchAll'])) {
        if (this.myTextInput && this.myTextInput.value !== '') {
          if (eduParam.getIn(['filter', 'searchAll'])) {
            this.myTextInput.value = eduParam.getIn(['filter', 'searchAll']);
          } else {
            SEARCH_VALUE = '';
            this.myTextInput.value = '';
            CurrentStatusActions.changeEdu({ name: 'isSearchActive', value: false });
          }
        }
      } else {
        if (!searchValue) {
          CurrentStatusActions.changeEdu({ name: 'isSearchActive', value: false });
        }
      }
    }, 100);
  };

  // 검색 취소
  onClearSearch = () => {
    let searchValue = '';
    const { CurrentStatusActions } = this.props;

    SEARCH_VALUE = '';
    searchValue = SEARCH_VALUE;

    CurrentStatusActions.changeEdu({ name: 'isSearchActive', value: false });
    CurrentStatusActions.changeEdu({ name: 'searchText', value: searchValue });

    setTimeout(() => {
      this.onSearch();
    }, 100);

    if (this.myTextInput && this.myTextInput.value !== '') {
      this.myTextInput.value = '';
    }
  };

  // 교육 검색
  onSearch = () => {
    let searchValue = '';
    const { CurrentStatusActions, EduActions, eduParam } = this.props;
    const filter = eduParam.get('filter').toJS();
    delete filter['searchAll'];

    searchValue = SEARCH_VALUE;

    if (this.myTextInput && this.myTextInput.value !== '') {
      this.myTextInput.value = searchValue;
    }

    CurrentStatusActions.changeEdu({ name: 'searchText', value: searchValue });
    CurrentStatusActions.changeEdu({ name: 'selectEduNo', value: 'all' });
    EduActions.changeEduParam({
      name: 'filter',
      value: !!searchValue ? fromJS({ ...filter, searchAll: searchValue }) : fromJS(filter)
    });
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  // 교육 수정 모달 - 훈련 선택 dropdown
  handleChangeExam = (e, value) => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.changeEduExam({
      selectEduExamNoArray: value
    });
  };

  render() {
    // 데이터
    const {
      currentPath,
      eduSummaryOrdering,
      eduSummaryByEduNo,
      isModal,
      isAllOpen,
      isOpen,
      selectEduNo,
      selectEditEduNo,
      formEduEdit,
      eduParam,
      eduExamByExamNo,
      eduExamOrdering,
      examNoArray,
      selectEduExamNoArray,
      formStoreEdit
    } = this.props;
    // function
    const {
      handleChangeExam,
      onSelectEduSummary,
      onToggleModal,
      onEduToggleModal,
      onExamEdit,
      onDeleteEdu,
      onPutEdu
    } = this;
    // 검색
    const { isSearchActive, searchText } = this.props;
    const { onSearchActive, onSearch, onChangeSearch, onKeyupSearch, onClearSearch } = this;

    return (
      <EduSummary
        currentPath={currentPath}
        eduSummaryOrdering={eduSummaryOrdering}
        eduSummaryByEduNo={eduSummaryByEduNo}
        // 버튼 클릭여부
        isClicked={this.state.isClicked}
        isLoading={this.state.isLoading}
        isModal={isModal}
        isAllOpen={isAllOpen}
        // isOpen={isOpen}
        // 필터
        filter={eduParam.get('filter').toJS()}
        // 조회/등록/수정/삭제
        formEduEdit={formEduEdit}
        eduExamByExamNo={eduExamByExamNo}
        eduExamOrdering={eduExamOrdering}
        examNoArray={examNoArray}
        handleChangeExam={handleChangeExam}
        onSelectEduSummary={onSelectEduSummary}
        onEduToggleModal={onEduToggleModal}
        onExamEdit={onExamEdit}
        onDeleteEdu={onDeleteEdu}
        onPutEdu={onPutEdu}
        formStoreEdit={formStoreEdit}
        // 교육 및 훈련 선택
        selectEduNo={selectEduNo}
        selectEditEduNo={selectEditEduNo}
        selectEduExamNoArray={selectEduExamNoArray}
        // 교육 검색
        onSearchActive={onSearchActive}
        searchProps={{
          searchText: searchText,
          isSearchActive: isSearchActive,
          onSearchActive: onSearchActive,
          onSearch: onSearch,
          onChangeSearch: onChangeSearch,
          onKeyupSearch: onKeyupSearch,
          onClearSearch: onClearSearch
        }}
        // 모달
        onToggleModal={onToggleModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  needReload: state.edu.get('needReload'),
  eduParam: state.edu.get('param'),
  path: state.edu.get('path'),
  page: state.edu.get('page'),
  isModal: state.currentStatus.get('isModal'),
  // 상세 보기 선택한 교육 번호
  selectEduNo: state.currentStatus.getIn(['edu', 'selectEduNo']),
  // 편집 선택한 교육 번호
  selectEditEduNo: state.currentStatus.getIn(['edu', 'selectEditEduNo']),
  selectEduExamNoArray: state.currentStatus.get('selectEduExamNoArray'),
  // 교육 리스트
  eduSummaryOrdering: state.edu.get('eduSummaryOrdering'),
  eduSummaryByEduNo: state.edu.get('eduSummaryByEduNo'),
  // 훈련 리스트
  eduExamByExamNo: state.edu.get('eduExamByExamNo'),
  eduExamOrdering: state.edu.get('eduExamOrdering'),
  examNoArray: state.edu.get('examNoArray'),
  // 검색
  isSearchActive: state.currentStatus.getIn(['edu', 'isSearchActive']),
  searchText: state.currentStatus.getIn(['edu', 'searchText']),
  // form
  formStoreEdit: state.form['formEduEdit'],
  formEduEdit: getFormValues('formEduEdit')(state),
  formEduEditIsValid: isValid('formEduEdit')(state)
});

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch),
  Dispatch: dispatch
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtEduSummary)));



// WEBPACK FOOTER //
// ./src/script/containers/edu/CtEduSummary.js